import { CloudUploadOutlined } from '@vindr/icons';
import { Button } from 'antd';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useCaptureManagerState } from '../context';

const UploadIcon = () => {
  const { t } = useTranslation('Vindoc');
  const { selected, handleUploadFiles } = useCaptureManagerState();

  return (
    <Button
      className="flex items-center text-3xl"
      type="primary"
      title={t('Upload Files')}
      onClick={handleUploadFiles}
      disabled={
        isEmpty(selected) ||
        selected.every(
          (it) =>
            ['success', 'converting'].includes(it.process?.status) ||
            (it.tag === 'video' && !it.name.endsWith('.mp4'))
        )
      }
      icon={<CloudUploadOutlined />}
    >
      <span className="text-base">{t('Upload')}</span>
    </Button>
  );
};

export default UploadIcon;
